import React, { useRef, useEffect, useState} from 'react';
import { useLoadScript } from '@react-google-maps/api';
import { useFormContext } from 'react-hook-form';
import axiosInstance from '../../utils/axiosInstance';

const libraries = ['places'];

const AddressTable = ({ 
    selectedCompany,
    companyAddresses,
    setIsLoading,
    googleMapsApiKey
}) => {
    const { setValue } = useFormContext();
    const [newAddress, setNewAddress] = useState('')
    const [newAddressObj, setNewAddressObj] = useState('')
    const [isAddressSelected, setIsAddressSelected] = useState(false)
    const [addresses, setAddresses] = useState(companyAddresses)
    const { isLoaded } = useLoadScript({
        googleMapsApiKey,
        libraries,
    });
    const addressInputRef = useRef(null);
    
    const reloadAddresses = async () => {
        try {
            const response = await axiosInstance.get(`/companies/${selectedCompany.id}/company_addresses.json`);
            setAddresses(response.data.addresses)
        } catch (error) {
            console.error("Error fetching address: ", error);
        }
    };

    const deleteAddresss = async (id) => {
        try {
            if (window.confirm("Are you sure you want to delete this address?")) {
                const response = await axiosInstance.delete(`/companies/${selectedCompany.id}/company_addresses/${id}.json`)
                reloadAddresses()
            }
        } catch (error) {
            console.error("There was an error deleting the address:", error)
        }
    }

    const handleAddAddress = async () => {
        setIsLoading(true);
        try {     
            const response = await axiosInstance.post(`/companies/${selectedCompany.id}/company_addresses.json`, {
                address: newAddress,
                company_address: {
                    name: newAddressObj.formatted_address,
                    latitude: newAddressObj.geometry.location.lat(),
                    longitude: newAddressObj.geometry.location.lng()
                }
            });

            if(response){
                reloadAddresses();
                setNewAddress('');
                setNewAddressObj(null);
                setIsAddressSelected(false);

                if (addressInputRef.current) {
                    addressInputRef.current.value = '';
                }
            }
        } catch (error) {
            console.error("Error adding address: ", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        reloadAddresses();
    }, [selectedCompany]);

   // Show full address selected
    useEffect(() => {
        if (isLoaded && addressInputRef.current) {
            const autocomplete = new google.maps.places.Autocomplete(addressInputRef.current, {
                componentRestrictions: { country: ['za', 'eg'] },
                fields: ['geometry', 'formatted_address'],
            });
        
            autocomplete.addListener('place_changed', () => {
                const place = autocomplete.getPlace();
                if (place && place.formatted_address) {
                    setNewAddress(place.formatted_address);
                    setNewAddressObj(place);
                    setIsAddressSelected(true);
                    setValue('newAddress', place.formatted_address, { shouldDirty: false });
                }
            });

            google.maps.event.addDomListener(addressInputRef.current, 'keydown', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                }
            });
        }
    }, [isLoaded]);

    const getInputWrapperStyle = () => {
        if (newAddress && !isAddressSelected) {
            return {
                padding: '2px',
                backgroundColor: 'rgb(252, 165, 165)', // bg-red-300 equivalent
                borderRadius: '6px',
                animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
            };
        }
        
        return {};
    };

    return (
        <div className="flex flex-wrap">
            <div className="w-full flex items-center">
                <div className="w-full pr-4">
                    <div style = {getInputWrapperStyle()}>
                        <input
                            id={`autocomplete`}
                            defaultValue={newAddress}
                            onInput={(e) => {
                                const inputValue = e.target.value;
                                setNewAddress(inputValue);
                                if (isAddressSelected && inputValue !== newAddressObj.formatted_address) {
                                    setIsAddressSelected(false);
                                }
                            }}
                            placeholder="Search Address"
                            ref={addressInputRef}
                            style={{ 
                                width: '100%', 
                                padding: '12px', 
                                border: '1px solid #ccc', 
                                borderRadius: '4px' 
                            }}
                            className={`input border text-sm py-1 rounded-lg w-full md:w-3/4 lg:w-5/6 border-gray-400 text-gray-900 px-2`}
                        />
                    </div>
                </div>
                <button
                    className={`button rounded flex items-center justify-center relative cursor-pointer ${
                        !isAddressSelected ? "bg-gray-400" : "button"
                    }`}
                    style={{ width: "40px", height: "45px", marginRight: "15px" }}
                    onClick={()=> handleAddAddress()}
                    disabled={!isAddressSelected}
                >
                    <i className="fas fa-save" />
                </button>
            </div>

            <div className="w-full mt-3 mb-2">
                <table className="table-auto w-full">
                    <thead>
                        <tr>
                            <th className="text-left px-2 py-2 align-left text-sm">Address</th>
                        </tr>
                    </thead>
                    <tbody>
                        {addresses.map((address, index) => (
                            <tr key={index} className="border-t text-gray-900 text-sm">
                                <td className="px-4 py-2 text-red">{address.name}</td>
                                <td className="px-4 py-2">
                                <div className="flex justify-end">
                                    <button
                                        type="submit"
                                        className="bg-red-600 text-white rounded font-bold text-sm items-center justify-center relative cursor-pointer" 
                                        style={{ width: "40px", height: "45px" }}
                                        onClick={()=> deleteAddresss(address.id)}
                                    >
                                        <i className="fas fa-trash-alt"></i>
                                    </button>
                                </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AddressTable;